import {
	ReactElement,
	useCallback
} from "react";
import classNames from "classnames";
import {
	ZaaksysteemCaseListItemModel,
	ZaaksysteemCaseStatus
} from "client/Api/Workspace/LiveInformation/Zaaksysteem/zaaksysteemLiveInformation";
import { ListItem } from "../ListItem";
import { generateTrackingId } from "client/Misc/utils";
import styles from "./ZaaksysteemListItem.module.less";
import { PipeSeparator } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export type ZaaksysteemListItemProps = {
	data: ZaaksysteemCaseListItemModel;
	shouldUseWideTemplate: boolean;
	onNavigate(url: string): void;
};

export const ZaaksysteemListItem = (props: ZaaksysteemListItemProps): ReactElement => {
	const {
		data,
		shouldUseWideTemplate,
		onNavigate
	} = props;

	const {
		caseNumber,
		caseType,
		navigationUrl,
		requester,
		status,
		subject
	} = data;

	const navigateHandler = useCallback(
		(): void => {

			onNavigate(navigationUrl);
		},
		[
			navigationUrl,
			onNavigate
		]
	);

	const renderInfo = (): ReactElement => {
		return (
			<>
				{caseType}
				{requester && shouldUseWideTemplate && (
					<>
						<PipeSeparator />
						{requester}
					</>
				)}
			</>
		);
	};

	return (
		<ListItem
			trackingId={generateTrackingId("case", `|${caseNumber}`)}
			isHoverable
			onClick={navigateHandler}
			title={subject}
		>
			<ListItem.Icon>
				<div
					className={classNames(
						styles.icon,
						{
							[styles.icon_stalled]: status === ZaaksysteemCaseStatus.Stalled
						}
					)}
				/>
			</ListItem.Icon>

			<ListItem.Content>
				<ListItem.Row>
					<ListItem.Title>
						{subject
							? subject
							: localize("_NoDescription")
						}
					</ListItem.Title>
				</ListItem.Row>

				<ListItem.Row verticalAlignment="center">
					<ListItem.Info>
						{renderInfo()}
					</ListItem.Info>
					<ListItem.RightAddition>
						<ListItem.Info>
							#{caseNumber}
						</ListItem.Info>
					</ListItem.RightAddition>
				</ListItem.Row>
			</ListItem.Content>
		</ListItem>
	);
};
ZaaksysteemListItem.displayName = "ZaaksysteemListItem";